// extracted by mini-css-extract-plugin
module.exports = {"clusterMarker":"styles_clusterMarker__f4Uwg"};